import { createElementBlock as l, openBlock as o, createElementVNode as r } from "vue";
const t = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
};
function n(c, e) {
  return o(), l("svg", t, e[0] || (e[0] = [
    r("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M10.184 3.552c.715-1.55 2.917-1.55 3.632 0l1.961 4.252 4.65.551c1.694.2 2.375 2.296 1.122 3.454l-3.437 3.18.912 4.591c.333 1.674-1.45 2.969-2.939 2.135L12 19.43l-4.085 2.286c-1.49.834-3.272-.46-2.939-2.135l.913-4.592L2.45 11.81c-1.253-1.16-.572-3.254 1.123-3.455l4.649-.551z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const i = { render: n };
export {
  i as default,
  n as render
};
//# sourceMappingURL=ic_star_filled-Bdpoy39d.js.map
